// extracted by mini-css-extract-plugin
export var rateTable = "_57-0";